import { IconButton, Input, InputAdornment, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CropFreeIcon from '@material-ui/icons/CropFree';
import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setMaterialFilterKey, setSelection } from '../../store/actions';
import SelectDialog from '../SelectDialog';
import MaterialTable from './material';
import SelectedChip from './selected';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from 'src/utils/axios';
import { resetMaterials, getMaterialRequest } from 'src/store/actions';

const useStyles = makeStyles(theme => ({
  root: {
    color: 'white',
    padding: '2px'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    width: '97%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  }
  
}));

function SelectMaterial(props) {
  const classes = useStyles();
  const [openBarkod, setOpenBarkod] = useState(false);
  const { t } = useTranslation('work_order');


  const setAddProductMaterial = () => {

    if (props?.materials?.filterKey?.length < 6) {
      return;
    }
    if (props?.ProductCode?.length < 5) {
      return;
    }

    const Uyari = t('lblSure');
    const confirmation = window.confirm(Uyari);
    if (!confirmation) {
      return;
    }
    const data = {
      Sku: props?.ProductCode,
      MaterialCode: props?.materials?.filterKey,
      WorkOrderId: props?.ReceiptNo
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('/SetAddProductMaterial', data, config)
      .then(response => {
        props.resetMaterials();
        props.getMaterialRequest(props?.ProductCode, 1, 1, 0, 0);
      })
      .catch(error => {
       
      });
   
  }

 

  return (
    <SelectDialog
      open={props.open}
      title={`${props.defect} ${t('Hizmet')} ${props.title}`}
      onClose={props.onClose}
      isDefectDialog={true}
      onEntering={() => props.setMaterialFilterKey('')}
      actions
      setGosterimAdet={props.setGosterimAdet}
      GosterimAdet={props.GosterimAdet}
      SearchField={
        <div className={classes.fields}>
          <Input
            onChange={event => props.setMaterialFilterKey(event.target.value)}
            value={props.materials.filterKey}
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end">
                  <SearchIcon />
                </IconButton>
                <IconButton
                  color="primary"
                  aria-label="settings"
                  onClick={() => setOpenBarkod(true)}
                >
                  <CropFreeIcon />
                </IconButton>
                <IconButton edge="end">
                  <AddBoxIcon
                    onClick={() => setAddProductMaterial()}
                  />
                </IconButton>
              </InputAdornment>
            }
            aria-describedby="standard-weight-helper-text"
            placeholder={t('lblMalzemeAra')}
          />
        </div>
      }
      SelectedItems={<SelectedChip defect={props.defect} />}
    >
      <MaterialTable
        defect={props.defect}
        openBarkod={openBarkod}
        ReceiptNo={props.ReceiptNo}
        setOpenBarkod={setOpenBarkod}
        GosterimAdet={props.GosterimAdet}
      />
    </SelectDialog>
  );
}

const mapStateToProps = state => ({
  defects: state.defectReducer,
  materials: state.materialReducer
});

const mapDispatchToProps = {
  setSelection,
  setMaterialFilterKey,
  resetMaterials,
  getMaterialRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectMaterial);
